export default {
  // 매장정보 반환
  getRestaurantInfo (state) {
    return state.restaurant
  },
  // 대기열 목록 반환
  getQueueList (state) {
    return state.queueList
  },
  // 대기열 세분화 사용여부 반환
  isUseParallelQueue (state) {
    return state.restaurant.useWaitingQueue
  },
  isSocketDisconnected (state) {
    return state.isSocketDisconnected
  },
  getWaitingParams (state) {
    return state.waitingParams
  },
  isOffline (state) {
    return state.isOffline
  },
  getSocketInstance (state) {
    return state.socket
  },
  getRefreshToken (state) {
    return state.refreshToken || localStorage.getItem('refreshToken')
  },
  getAccessToken (state) {
    return state.accessToken || localStorage.getItem('accessToken')
  },
  getStoreIdx (state) {
    let storeIdx = (state.restaurant.idx > 0) ? state.restaurant.idx : localStorage.getItem('restaurantIdx')
    return storeIdx || -1
  }
}
